export const ENDPOINTS = {
   
    menuItems: "/menu/items"
   
};